// Copyright (C) 2020-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import Popover from 'antd/lib/popover';
import Icon from '@ant-design/icons';

import { Canvas } from 'labelops-canvas-wrapper';
import { EllipseIcon } from 'icons';
import { ShapeType } from 'reducers';

import DrawShapePopoverContainer from 'containers/annotation-page/standard-workspace/controls-side-bar/draw-shape-popover';
import withVisibilityHandling from './handle-popover-visibility';

export interface Props {
    canvasInstance: Canvas;
    isDrawing: boolean;
    disabled?: boolean;
}

const CustomPopover = withVisibilityHandling(Popover, 'draw-ellipse');
function DrawEllipseControl(props: Props): JSX.Element {
    const { canvasInstance, isDrawing, disabled } = props;
    const dynamicPopoverProps = isDrawing ? {
        overlayStyle: {
            display: 'none',
        },
    } : {};

    const dynamicIconProps = isDrawing ? {
        className: 'labelops-draw-ellipse-control labelops-active-canvas-control',
        onClick: (): void => {
            canvasInstance.draw({ enabled: false });
        },
    } : {
        className: 'labelops-draw-ellipse-control',
    };

    return disabled ? (
        <Icon className='labelops-draw-ellipse-control labelops-disabled-canvas-control' component={EllipseIcon} />
    ) : (
        <CustomPopover
            {...dynamicPopoverProps}
            overlayClassName='labelops-draw-shape-popover'
            placement='right'
            content={<DrawShapePopoverContainer shapeType={ShapeType.ELLIPSE} />}
        >
            <Icon {...dynamicIconProps} component={EllipseIcon} />
        </CustomPopover>
    );
}

export default React.memo(DrawEllipseControl);
